import { ArrowCircleLeftIcon } from "@heroicons/react/solid";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import SideBar from "../../../components/b2b/SideBar";
import SearchResultHeading from "../../../components/b2c/SearchResultHeading";
import VehiclePriceCard from "../../../components/b2c/VehiclePriceCard";
import Header from "../../../components/landingPage/Header";
import LoadingSkeleton from "../../../components/loading/LoadingSkeleton";
import { getVehicle } from "../../../redux/app/vehicle/vehicle-slice";
import momenttz from "moment-timezone";
import moment from "moment-timezone";
import axios from "axios";

const OfflineBookingCars = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { token, user } = useSelector((state) => state.auth);
  const {
    booking,
    timezone,
    distance,
    selectdCurrency,
    bookingDuration,
    dateTimeIST,
  } = useSelector((state) => state.booking);
  const { allVehicles } = useSelector((state) => state.vehicle);

  const [vehiclePrice, setvehiclePrice] = useState();

  useEffect(() => {
    if (booking.destination?.lat && booking.destination?.lng) {
      dispatch({
        type: "GET_DISTANCE_BETWEEN_SOURCE_AND_DESTINATION",
        payload: {
          sourcelatlng: booking?.source?.lat + "," + booking?.source?.lng,
          destlatlng: booking.destination?.lat + "," + booking.destination?.lng,
        },
      });
    }
  }, [booking.destination?.lat, booking.destination?.lng]);

  const [vehicleWithPrice, setvehicleWithPrice] = useState({});

  const handleBooking = async (vehicle) => {
    let travelTimeStampObj = new Date(
      booking.travelDate + " " + booking.travelTime.split(" ")[1]
    );

    const response = await axios.get(
      `${process.env.REACT_APP_BASE_URL}/places/placeTimezone?lat=${booking?.source?.lat}&lng=${booking?.source?.lng}`
    );

    let travelDate = moment(booking.travelDate).format("YYYY-MM-DD");

    let travelTime = booking.travelTime.split(" ")[1];

    const dateTime = momenttz.tz(
      `${travelDate} ${travelTime}`,
      response?.data?.timezone
    );

    const formattedTimestamp = dateTime.format();

    const payload = {
      source: booking.source,
      destination: booking.destination,
      travelDate: booking.travelDate,
      travelTime: booking.travelTime.split(" ")[1],
      travelTimeStamp: formattedTimestamp,
      duration: bookingDuration,
      passenger: booking.passenger,
      bookingType: booking.bookingType,
      travelDistance: distance,
      priceDetails: {
        amount: vehicleWithPrice[vehicle.vehicleName],
        currency: selectdCurrency,
      },
      timeZone: booking.timeZone,

      vehicle: {
        vehicleName: vehicle.vehicleName,
      },
      userName: user?.userName + " (Offline)",
      indianTravelDate: moment(dateTimeIST?.converted_time).format(),
      indianTravelTime: moment(dateTimeIST?.converted_time).format("HH:mm"),
    };

    const hourlyPayload = {
      source: booking.source,      
      travelDate: booking.travelDate,
      travelTime: booking.travelTime.split(" ")[1],
      travelTimeStamp: formattedTimestamp,
      duration: `${booking.duration} hours`,
      passenger: booking.passenger,
      bookingType: booking.bookingType,      
      travelDistance: distance,
      priceDetails: {
        amount: vehicleWithPrice[vehicle.vehicleName],
        currency: selectdCurrency,
      },
      timeZone: booking.timeZone,

      vehicle: {
        vehicleName: vehicle.vehicleName,
      },
      userName: user?.userName + " (Offline)",
      indianTravelDate: moment(dateTimeIST?.converted_time).format(),
      indianTravelTime: moment(dateTimeIST?.converted_time).format("HH:mm"),
    };

    dispatch({
      type: "BOOKING_INITIATE_WITH_VEHICLE",
      payload: {
        payload:booking.bookingType==="HOURLY"?hourlyPayload:payload,
        navigate,
        b2b: true,
      },
    });
    dispatch(
      getVehicle({
        vehicle,
      })
    );
  };

  useEffect(() => {
    window.addEventListener("beforeunload", alertUser);
    return () => {
      window.removeEventListener("beforeunload", alertUser);
      // window.location.pathname = "/newbooking";
    };
  }, []);

  const alertUser = (e) => {
    e.preventDefault();
    e.returnValue = "";
    localStorage.setItem("relodePage", "true");
  };

  useEffect(() => {
    if (localStorage.getItem("relodePage")) {
      localStorage.removeItem("relodePage");
      navigate("/offlinebooking");
    }
  }, [navigate]);
  return (
    <div className="h-screen w-screen fixed">
      <Header token={token} />
      <div className="flex">
        <SideBar />
        <div className="w-screen  ">
          <div className="md:space-x-2 space-x-5 mx-6">
            <div>
              <Link to="/offlinebooking">
                <ArrowCircleLeftIcon className="w-8 text-gray-600 mt-3" />
              </Link>
            </div>
            <SearchResultHeading
              b2b={true}
              searchCompleted={true}
              chVehicleCurrent={true}
              showBookingDetail={true}
            />
          </div>
          <div className="h-[90vh] overflow-y-auto scrollbar">
            <div className="lg:overflow-y-auto">
              {allVehicles?.map((vehicle) => (
                <div className="my-12">
                  <VehiclePriceCard
                    b2b={true}
                    key={vehicle?.vehicleId}
                    vehicleName={vehicle?.vehicleName}
                    passengers={vehicle?.passengerCount}
                    luggages={vehicle?.luggageCount}
                    description={vehicle?.description}
                    image={vehicle?.vehicleImage?.secure_url}
                    price={vehicle?.price}
                    unit={vehicle?.unit}
                    isOffLine={true}
                    priceInputChange={(e) => {
                      // setvehiclePrice(e.target.value);
                      vehicleWithPrice[vehicle.vehicleName] = e.target.value;
                      setvehicleWithPrice(vehicleWithPrice);
                    }}
                    priceValue={vehicleWithPrice[vehicle.vehicleName]}
                    onClick={() => handleBooking(vehicle)}
                  />
                </div>
              ))}

              <div className="mb-32"></div>
              {/* <VehiclePriceCard /> */}
            </div>
            <div className="pb-32"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OfflineBookingCars;
